import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Remuneration rules shared by the mission-creation forms.
 *  - Accepts a comma decimal separator ("11,5" === 11.5).
 *  - Minimum depends on the compensation unit: HOUR = 10 €/h, DAY/MONTH = 50.
 *  - Maximum = 9999.
 */
export const REMUNERATION_MAX = 9999;
export const REMUNERATION_MIN_HOUR = 10;
export const REMUNERATION_MIN_DAY = 50;

/** Parse a remuneration value that may use a comma decimal separator (e.g. "11,5"). */
export function parseRemuneration(value: any): number {
  if (value === null || value === undefined || value === '') {
    return NaN;
  }
  return parseFloat(String(value).replace(',', '.').trim());
}

/** Minimum remuneration for a compensation type: HOUR = 10, otherwise (DAY / MONTH) = 50. */
export function minRemunerationFor(compensationType: string | null | undefined): number {
  return compensationType === 'HOUR' ? REMUNERATION_MIN_HOUR : REMUNERATION_MIN_DAY;
}

/**
 * Validator for the `compensationproposednet` control. Reads the sibling `compensationType`
 * control to pick the minimum, and accepts a comma decimal separator. Emptiness is left to
 * Validators.required so the two concerns stay independent.
 */
export function remunerationValidator(max: number = REMUNERATION_MAX): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw === null || raw === undefined || raw === '') {
      return null;
    }
    const num = parseRemuneration(raw);
    if (isNaN(num)) {
      return { remuneration: { reason: 'nan' } };
    }
    const min = minRemunerationFor(control.parent?.get('compensationType')?.value);
    if (num < min) {
      return { remuneration: { min } };
    }
    if (num > max) {
      return { remuneration: { max } };
    }
    return null;
  };
}
